import React, {FC} from "react"
import {Col} from "@irati/ui/src/Layout"

import {getActiveProducts} from "@irati/products/utils/products"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import idHelper from "@irati/utils/id"

import authentication from "@irati/auth"
import {SectionHeader} from "../styled"
import HomePageRow from "../HomePageRow"
import ProductTile from "./Product"

interface Props {
  id: string
}

const TenantProducts: FC<Props> = (props) => {
  // Show TenantProducts just if we're hiding homepage lanes (Business FeatureFlag)
  const showTenantProducts = authentication.apps("platform.homepageLanesHidden")
  if (!showTenantProducts) {
    return null
  }
  const id = idHelper("tenant-products", props)
  const activeProducts = getActiveProducts()

  return (
    <HomePageRow id={id}>
      <Col xs={12}>
        <SectionHeader>
          <H3>
            <FormattedMessage id="platform.homepage.products.title" />
          </H3>
        </SectionHeader>
        <div>
          {activeProducts.map((product, i) => (
            <ProductTile id={id} key={product.product} product={product} isLast={i === activeProducts.length - 1} />
          ))}
        </div>
      </Col>
    </HomePageRow>
  )
}

export default TenantProducts
